import design from "./bob-design.json";

/** Shared lighting for SVG branding, soft curves and their particle textures. */
export function BobPaint({ id }: { readonly id: string }) {
  return (
    <defs>
      {(["light", "dark"] as const).map((tone) => (
        <linearGradient key={tone} id={`${id}-${tone}`} x1="0" y1="0" x2="0.85" y2="1">
          {design.material[tone].map((color, index) => (
            <stop key={color} offset={design.material.stops[index]} stopColor={color} />
          ))}
        </linearGradient>
      ))}
      <linearGradient id={`${id}-rim`} x1="0" y1="0" x2="0.65" y2="1">
        {design.material.rim.map((stop) => (
          <stop
            key={stop.offset}
            offset={stop.offset}
            stopColor={stop.color}
            stopOpacity={stop.opacity}
          />
        ))}
      </linearGradient>
    </defs>
  );
}
